import api from './api';

export const propertyService = {
  /**
   * Récupérer tous les biens avec filtres
   * @param {Object} filters - { typeBien, ville, zone, prixMin, prixMax, search, page, limit }
   * @returns {Promise}
   */
  getAllProperties: async (filters = {}) => {
    try {
      const response = await api.get('/properties', { params: filters });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des biens:', error);
      throw error;
    }
  },

  /**
   * Récupérer un bien par son ID
   * @param {string} id - ID du bien
   * @returns {Promise}
   */
  getPropertyById: async (id) => {
    try {
      const response = await api.get(`/properties/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération du bien:', error);
      throw error;
    }
  },

  /**
   * Créer un nouveau bien (Admin/Agent uniquement)
   * @param {Object} data - Données du bien
   * @returns {Promise}
   */
  createProperty: async (data) => {
    try {
      const response = await api.post('/properties', data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création du bien:', error);
      throw error;
    }
  },

  /**
   * Mettre à jour un bien (Admin/Agent uniquement)
   * @param {string} id - ID du bien
   * @param {Object} data - Nouvelles données
   * @returns {Promise}
   */
  updateProperty: async (id, data) => {
    try {
      const response = await api.patch(`/properties/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour du bien:', error);
      throw error;
    }
  },

  /**
   * Supprimer un bien (Admin uniquement)
   * @param {string} id - ID du bien
   * @returns {Promise}
   */
  deleteProperty: async (id) => {
    try {
      const response = await api.delete(`/properties/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression du bien:', error);
      throw error;
    }
  },

  syncImages: async (id, images) => {
    try {
      const response = await api.post(`/properties/${id}/images`, { images });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la synchronisation des images:', error);
      throw error;
    }
  },

  toggleVedette: async (id) => {
    try {
      const response = await api.patch(`/properties/${id}/vedette`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors du toggle vedette:', error);
      throw error;
    }
  },
};

export default propertyService;
